<template>
  <div>
    <v-img
      :aspect-ratio="16 / 9"
      height="450"
      :src="require('@/assets/images/news/dji_20250904140448_0006_v1.jpg')"
    ></v-img>

    <v-container class="text-justify">
      <h1 class="mb-4">{{ $t("terminalExpansionNews.title") }}</h1>

      <p v-html="$t('terminalExpansionNews.p1')"></p>
      <p v-html="$t('terminalExpansionNews.p2')"></p>
      <p v-html="$t('terminalExpansionNews.p3')"></p>
      <p v-html="$t('terminalExpansionNews.p4')"></p>
      <p v-html="$t('terminalExpansionNews.p5')"></p>

      <h2 class="mt-4 mb-2">
        {{ $t("terminalExpansionNews.subtitle_advances") }}
      </h2>
      <div
        v-html="$t('terminalExpansionNews.list_advances')"
        class="mb-4 pl-4"
      ></div>

      <h2 class="mt-4 mb-2">
        {{ $t("terminalExpansionNews.subtitle_impact") }}
      </h2>
      <p v-html="$t('terminalExpansionNews.p_impact_1')"></p>
      <p v-html="$t('terminalExpansionNews.p_impact_2')"></p>
      <p
        class="font-weight-bold"
        v-html="$t('terminalExpansionNews.p_impact_3')"
      ></p>

      <v-row class="mt-5">
        <v-col cols="12" md="6">
          <v-img
            :src="
              require('@/assets/images/news/dji_20250904140448_0006_v1.jpg')
            "
            height="300"
            contain
            class="grey lighten-2"
          ></v-img>
        </v-col>
        <v-col cols="12" md="6">
          <v-img
            :src="
              require('@/assets/images/news/dji_20250722152827_0001_v2.jpg')
            "
            height="300"
            contain
            class="grey lighten-2"
          ></v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
